import { FilterableInterface } from './filterable.interface';

export class NonProductiveManufacturingOrder implements FilterableInterface {
  constructor(
    public hash?: string,
    public code?: string,
    public projectNumber?: string,
    public description?: string,
    public categoryHash?: string,
    public categoryName?: string
  ) { }

  clone() {
    return new NonProductiveManufacturingOrder(
      this.hash,
      this.code,
      this.projectNumber,
      this.description,
      this.categoryHash,
      this.categoryName
    );
  }

  get filterableData() {
    return `${ this.code } ${ this.projectNumber }`.toLowerCase();
  }

  get codeWithNumber() {
    return `${ this.code }/${ this.projectNumber }`;
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/non-productive-manufacturing-order.ts